import React from 'react';
import { Table, Button, Badge, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';

const AcademicYearTable = ({
  academicYears = [],
  loading = false,
  onEdit,
  onDelete,
  onMakeCurrent,
  getStatusBadge,
}) => {
  return loading ? (
    <div className="text-center py-5">
      <Spinner animation="border" variant="primary" />
      <p className="mt-2">Loading academic years...</p>
    </div>
  ) : (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Sl</th>
          <th>Name</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Is Current</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {academicYears.length === 0 ? (
          <tr>
            <td colSpan="6" className="text-center text-muted">
              No academic years found. Click "New Academic Year" to create one.
            </td>
          </tr>
        ) : (
          academicYears.map((year, index) => (
            <tr key={year.id}>
              <td>{index + 1}</td>
              <td>{year.name ?? '-'}</td>
              <td>{year.start_date ?? '-'}</td>
              <td>{year.end_date ?? '-'}</td>
              <td>{getStatusBadge(year.status, year.is_current)}</td>
              <td>
                <Button
                  variant="outline-success"
                  size="sm"
                  className="me-2"
                  onClick={() => onMakeCurrent(year)}
                  disabled={Number(year.is_current) === 1}
                >
                  Make Current
                </Button>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="me-2"
                  onClick={() => onEdit(year)}
                >
                  <FaEdit />
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => onDelete(year)}
                >
                  <FaTrash />
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default AcademicYearTable;
